const t = (key) => window.I18n

export default t